export { templatesListRoute } from './route'
